import { Box, Typography } from '@mui/material';
import React from 'react';
import whattodo from '../../assets/images/Frame 114.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Orangelogo from '../../assets/images/Orangelogo.png';
import Knowmorebtn from '../../components/button/Knowmorebtn';
// Remove CheckCircleIcon import
import RoundCircleIcon from '../../assets/icons/RoundTickIcon.png';

const CaseStudyAboutClient = () => {
  return (
    <Box
      sx={{
        width: '100%',
        marginTop: '4rem',
        display: 'flex',
        flexDirection: { xs: 'column-reverse', sm: 'row' },
        padding: { xs: '0rem 1.2rem', sm: '0rem 3rem' },
        marginTop: { xs: '2rem', sm: '4rem' },
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', sm: '50%' },
          padding: {xs:"0rem",sm:"2rem 3rem 0rem 1rem"},
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Montserrat',
            fontSize: '1.6rem',
            fontWeight: '500',
            marginTop: '1.2rem',
          }}
        >
          About Client{' '}
        </Typography>

        {/* First paragraph without the tick */}
        <Typography
          sx={{
            fontFamily: 'Plus Jakarta Sans',
            marginTop: '1rem',
            color: 'rgba(51, 51, 51, 1)',
          }}
        >
          Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium ,Sed ut spiciatis uste natus Sed
          voluptatem accusantium ,Sed ut spiciatis uste natus.
        </Typography>

        {/* Second paragraph with tick */}
        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
          <Box
            component="img"
            src={RoundCircleIcon}
            sx={{ width: '1.5rem', height: '1.5rem', marginRight: '0.5rem' }}
            alt="Round tick icon"
          />
          <Typography
            sx={{
              fontFamily: 'Plus Jakarta Sans',
              color: 'rgba(51, 51, 51, 1)',
            }}
          >
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.
          </Typography>
        </Box>

        {/* Third paragraph with tick */}
        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
          <Box
            component="img"
            src={RoundCircleIcon}
            sx={{ width: '1.5rem', height: '1.5rem', marginRight: '0.5rem' }}
            alt="Round tick icon"
          />
          <Typography
            sx={{
              fontFamily: 'Plus Jakarta Sans',
              color: 'rgba(51, 51, 51, 1)',
            }}
          >
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: '90%', sm: '48%' },
        }}
      >
        <Box
          sx={{
            width: { xs: '18rem', sm: '32rem' },
          }}
        >
          <LazyLoadImage src={whattodo} effect="blur" width="100%" height="100%" />
        </Box>
      </Box>
    </Box>
  );
};

export default CaseStudyAboutClient;
